import React from "react";
const MenuIcon = ({ onClick = () => { }, style, color }) => {
    return (React.createElement("div", { style: style || {}, onClick: onClick },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z", fill: color }))));
};
export default MenuIcon;
//# sourceMappingURL=MenuIcon.js.map